export default __webpack_public_path__ + "static/media/k.6334d3a8.svg";